import { merge } from './merge';
export function mergeWith(...otherSources) {
    return merge(...otherSources);
}
